import { createAdminResource } from 'lib/admin-kit';
import oauthApplicationConfig from './config';

export default createAdminResource(oauthApplicationConfig).Show;
